import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import load_45global from "/app/middleware/load.global.ts";
import redirect_45global from "/app/middleware/redirect.global.ts";
import rev_45global from "/app/middleware/rev.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  load_45global,
  redirect_45global,
  rev_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}